<template>
  <div>
    <div class="new-item-field">
      <div>
        <sc-field
          class="field-group"
          :label="label"
          :message="message"
          :type="message ? 'is-danger' : ''"
        >
          <sc-input
            v-model="newElement"
            placeholder="Digite o novo elemento"
            :disabled="editMode"
          />
        </sc-field>
      </div>

      <br />

      <div class="input-field-button">
        <sc-tooltip
          label="Adicionar novo elemento a lista"
          position="is-bottom"
        >
          <sc-button
            theme="primary"
            icon-left="save"
            @click="() => this.addField()"
            :disabled="editMode"
          >
            Adicionar
          </sc-button>
        </sc-tooltip>
      </div>
    </div>

    <br />

    <sc-table
      v-if="this.data.length > 0"
      :data="this.data"
      :columns="this.columns"
    >
      <template slot-scope="props">
        <sc-table-column field="id" :visible="true">
          {{ props.row.id }}
        </sc-table-column>

        <sc-table-column>
          <sc-input
            v-if="props.row.id == selectedItemIdToEdit && editMode"
            v-model="props.row.key"
          />

          <span v-else>
            {{ props.row.key }}
          </span>
        </sc-table-column>

        <sc-table-column>
          <sc-tooltip label="Editar" position="is-bottom">
            <sc-button
              v-if="props.row.id != selectedItemIdToEdit"
              theme="primary"
              icon="pen"
              @click="() => handleEdit(props.row)"
            />
          </sc-tooltip>

          <sc-tooltip label="Salvar" position="is-bottom">
            <sc-button
              v-if="props.row.id == selectedItemIdToEdit && editMode"
              theme="primary"
              icon="save"
              @click="() => saveEdit(props.row)"
            />
          </sc-tooltip>

          <sc-tooltip label="Deletar" position="is-bottom" type="is-danger">
            <sc-button
              theme="danger"
              icon="trash"
              @click="() => deleteRow(props.row)"
            />
          </sc-tooltip>
        </sc-table-column>
      </template>
    </sc-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import {
  ScField,
  ScInput,
  ScTooltip,
  ScButton,
  ScTable,
  ScTableColumn,
  ScToast,
} from "@intelipost-js/secure-components";

const { mapState, mapActions } = createNamespacedHelpers(
  "integrations/integrationsHome"
);

export default {
  name: "iplink-modal-config-list-field",

  data() {
    return {
      text: "",
      data: [],
      newElement: "",
      selectedItemIdToEdit: null,
      editMode: false,
      columns: [],
      label: "",
      message: "",
    };
  },

  props: {
    fieldSchema: {
      type: Object
    }
  },

  computed: {
    ...mapState(["appConfigUpdated"]),
  },

  methods: {
    ...mapActions(["updateAppConfig"]),

    validate() {
      if (this.fieldSchema.required && this.data.length == 0) {

        this.message = 'É obrigatório informar ao menos um item';
        return false;

      }

      this.message = '';
      return true;
    },

    handleEdit(selectedItem) {
      this.selectedItemIdToEdit = selectedItem.id;
      this.editMode = !this.editMode;
    },

    saveEdit(selectedItem) {
      if (selectedItem.key === "") {
        return ScToast.danger(
          "O campo " + this.key_name + " não pode ser vazio"
        );
      }

      const app_config = {
        ...this.appConfigUpdated,
      };

      app_config[this.fieldSchema.name][selectedItem.id] = selectedItem.key;

      this.updateAppConfig(app_config);

      this.selectedItemIdToEdit = null;
      this.editMode = !this.editMode;
    },



    addField() {
      if (this.newElement === "") {
        return ScToast.danger("O novo item não pode ser vazio");
      }

      this.data.push({
        id: this.data.length,
        key: this.newElement,
      });

      const app_config = {
        ...this.appConfigUpdated,
      };

      if (app_config[this.fieldSchema.name] != null) {
        app_config[this.fieldSchema.name] = [
          ...app_config[this.fieldSchema.name],
          this.newElement,
        ];
      } else {
        app_config[this.fieldSchema.name] = [this.newElement];
      }

      this.updateAppConfig(app_config);
      this.clearInput();
    },

    deleteRow(row) {
      const app_config = JSON.parse(JSON.stringify(this.appConfigUpdated));

      for (var i = 0; i < this.data.length; i++) {
        if (this.data[i].key === row.key) {
          this.data.splice(i, 1);

          const dataReIndex = [];
          for (var j = 0; j < this.data.length; j++) {
            dataReIndex.push({
              id: j,
              key: this.data[j].key,
            });
          }

          this.data = dataReIndex;

          app_config[this.fieldSchema.name] = this.data.map((item) => item.key);
          this.updateAppConfig(app_config);
        }
      }
    },

    clearInput() {
      this.newElement = "";
    },
  },

  mounted() {
    this.columns = [
      {
        field: 'id',
        label: 'id',
      },
      {
        field: 'key',
        label: this.fieldSchema.list_title,
      },
      {
        field: 'action',
        label: 'ação',
      },
    ];


    var initialValues = this.appConfigUpdated[this.fieldSchema.name];
    if (Array.isArray(initialValues)) {
      for (var index = 0; index < initialValues.length; index++) {
        this.data.push({
          id: index,
          key: initialValues[index],
        });
      }
    }

    this.label = this.fieldSchema.title;
    if (!this.label) this.label = this.fieldSchema.name;
    this.label += this.fieldSchema.required ? ' (Obrigatório)' : ' (Opcional)';
  },

  components: {
    ScField,
    ScButton,
    ScInput,
    ScTooltip,
    ScTable,
    ScTableColumn,
    ScToast,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.new-item-field {
  display: flex;
  flex-direction: column;
}

.edit-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .label-field {
    display: flex;
    align-self: center;
    width: 25%;
  }

  .input-field {
    width: 75%;
  }
}

.form-map {
  display: flex;
  width: 100%;

  .form-map-buttons {
    display: flex;
    justify-content: flex-end;
  }
}

.b-table .table th .th-wrap {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/modal/components/ListField.vue